<form #cityForm="ngForm" class="row" disabled="disabled">
	<mat-form-field class="col">
		<mat-label>{{ label }} </mat-label>
		<input matInput aria-label="City" type="text" [placeholder]="placeholder" [id]="id" [name]="name"
			[matAutocomplete]="auto" [(ngModel)]="selectedCity.CITY_NAME" #searchString="ngModel" #searchStringInput
			[value]="selectedCity.CITY_NAME" [required]="required" (ngModelChange)="checkForId(searchString)"
			[disabled]="disabled"  />
		<button mat-icon-button matSuffix [attr.aria-label]="'City Valid'"
			[color]="selectedCity && selectedCity.ID ? 'primary' : 'warn'" tabindex="-1" [disabled]="disabled">
			<mat-icon mat-icon-button *ngIf="isLoading">
				<mat-spinner diameter="18"></mat-spinner>
			</mat-icon>
			<mat-icon mat-icon-button *ngIf="!isLoading && (cityForm.dirty || selectedCity.ID! > 0)">
				{{ (selectedCity.ID && (!onlyCalifornia || cityInCalifornia )) ? "done" : "close" }}
			</mat-icon>
		</button>
	</mat-form-field>
	<app-msg *ngIf="!isLoading" class="msg-position"
		[msg]="{MSG:searchString.errors?.['idRequired'], SUCCESS:!searchString.errors?.['idRequired']}"></app-msg>
	
	<app-msg *ngIf="displayRequiredMessage && !isLoading && !searchString.errors?.['idRequired']" class="msg-position"
		[msg]="requiredMsg"></app-msg>

	<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect($event.option.value)">
		<ng-container *ngIf="!isLoading">
			<mat-option *ngFor="let city of cities" [value]="city">
				{{city.CITY_NAME + ', ' + city.STATE?.STATE_NAME}}
			</mat-option>
		</ng-container>
	</mat-autocomplete>
</form>